import * as React from 'react';
import { Component } from 'react';

interface Props {
  show: boolean[];
  messages: string[];
}

export default class ErrorMessages extends Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const num = this.props.show.length;
    const errors = [] as any[];

    for (let i = num - 1; i >= 0; i--) {
      errors.push({ id: i, show: this.props.show[i], message: this.props.messages[i] });
    }

    return (
      <>
        {errors.map((error) => {
          if (error.show) {
            return <span key={error.id} id={`${error.id}_error`}>{error.message}</span>;
          }
        })}
      </>
    );
  }
}
